import React, { Children } from "react";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

const MasonaryWrapper = ({
  children,
  columnBreakPoints = { 350: 1, 600: 2, 950: 3, 1100: 4 },
  gutter = "0.6rem",
}) => {
  return (
    <ResponsiveMasonry columnsCountBreakPoints={columnBreakPoints}>
      <Masonry gutter={gutter}>{children}</Masonry>
    </ResponsiveMasonry>
  );
};

export default MasonaryWrapper;
